// Mock data for DK Latex Spuiten

export const company = {
  name: "DK Latex Spuiten",
  tagline: "Vakkundig & professioneel latex spuitwerk",
  experience: "25+ jaar ervaring",
  phone: "06 50 651 743",
  phoneRaw: "+31650651743",
  email: "info@dk-latexspuiten.nl",
  address: "Nederland",
  pricingFrom: "\u20AC 3,-",
  kvk: "",
};

export const navigation = [
  { label: "Home", href: "#home" },
  { label: "Diensten", href: "#diensten" },
  { label: "Werkwijze", href: "#werkwijze" },
  { label: "Projecten", href: "#projecten" },
  { label: "Veelgestelde vragen", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const services = [
  {
    title: "Wanden spuiten",
    description: "Strak en gelijkmatig latex spuitwerk voor al uw wanden \u2013 sneller en mooier dan rollen.",
    icon: "PaintRoller",
  },
  {
    title: "Plafonds spuiten",
    description: "Egale, witte plafonds zonder rolnerf. Ideaal voor zowel woonkamers als grote ruimtes.",
    icon: "Square",
  },
  {
    title: "Kozijnen binnen",
    description: "Binnenkozijnen en deuren netjes afgespoten voor een professionele, strakke afwerking.",
    icon: "DoorOpen",
  },
  {
    title: "Grote ruimtes",
    description: "Bedrijfspanden, hallen en grote interieurs \u2013 vakkundig, snel en betaalbaar gespoten.",
    icon: "Building2",
  },
  {
    title: "Particulier & zakelijk",
    description: "Of het nu uw woning of bedrijfspand is, wij leveren altijd hetzelfde hoge kwaliteit.",
    icon: "Users",
  },
  {
    title: "Nieuwbouw & renovatie",
    description: "Verse stucwerk afspuiten of een complete renovatie: wij komen, kijken en spuiten.",
    icon: "Hammer",
  },
];

export const usps = [
  { title: "25+ jaar ervaring", text: "Eén vaste vakman die uw klus van begin tot eind verzorgt." },
  { title: "Vanaf \u20AC 3,- per m\u00B2", text: "Eerlijke, transparante prijzen zonder verrassingen." },
  { title: "Super strakke afwerking", text: "Geen rolnerf, geen kwaststrepen \u2013 alleen een egaal resultaat." },
  { title: "Snel klaar", text: "Ruimtes binnen één dag in een frisse, nieuwe laag latex." },
];

export const process = [
  { step: "01", title: "Vrijblijvende offerte", text: "U vult het formulier in of belt ons. Binnen 24 uur ontvangt u een prijsopgave op maat." },
  { step: "02", title: "Voorbereiding", text: "Wij dekken meubels en vloeren netjes af, kitten naden en zorgen voor een schone ondergrond." },
  { step: "03", title: "Voorstrijken", text: "Bij nieuwe of poreuze wanden brengen wij eerst een hechtprimer aan voor een blijvend resultaat." },
  { step: "04", title: "Latex spuiten", text: "Met een professionele airless-spuit brengen wij de latex egaal en strak aan op uw wanden en plafonds." },
  { step: "05", title: "Oplevering", text: "Wij ruimen alles netjes op en leveren uw ruimte stofvrij en spuitklaar op." },
];

export const projects = [
  {
    title: "Herinrichting Waardse Tempel",
    location: "Heerhugowaard",
    image: "https://dk-latexspuiten.nl/wp-content/uploads/2021/04/DK-Latex-Spuiten-Herinrichting-Waardse-Tempel-heerhugowaard-scaled.jpg",
    category: "Zakelijk",
  },
  {
    title: "Nieuwbouwwoning",
    location: "Noord-Holland",
    image: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHx3aGl0ZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MTc5NjYwOHww&ixlib=rb-4.1.0&q=85",
    category: "Particulier",
  },
  {
    title: "Bedrijfspand kantoor",
    location: "Amsterdam",
    image: "https://images.unsplash.com/photo-1515511856280-7b23f68d2996?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHx3aGl0ZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MTc5NjYwOHww&ixlib=rb-4.1.0&q=85",
    category: "Zakelijk",
  },
  {
    title: "Woonkamer & plafond",
    location: "Alkmaar",
    image: "https://images.unsplash.com/photo-1596079890687-58c51d24889a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHx3aGl0ZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MTc5NjYwOHww&ixlib=rb-4.1.0&q=85",
    category: "Particulier",
  },
  {
    title: "Airless spuitwerk",
    location: "Op locatie",
    image: "https://images.pexels.com/photos/7493886/pexels-photo-7493886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Werkproces",
  },
  {
    title: "Renovatie woning",
    location: "Hoorn",
    image: "https://images.pexels.com/photos/5493655/pexels-photo-5493655.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Particulier",
  },
];

export const faqs = [
  {
    q: "Is voorstrijken voor latex spuiten belangrijk?",
    a: "Voor nieuw gestukte muren is voorstrijken echt belangrijk om een goed hechtende, blijvende laag te krijgen. Bij oudere muren is het soms niet nodig \u2013 dat beoordelen wij tijdens een korte bezichtiging vooraf.",
  },
  {
    q: "Wat gebeurt er met naden en scheuren?",
    a: "Naden en scheuren werken wij altijd eerst weg met een goede acrylaatkit. Zo voorkomen we dat ze later weer doorkomen in de afwerking.",
  },
  {
    q: "Is latex spuiten mooier dan rollen of kwasten?",
    a: "Op grotere oppervlaktes zorgt latex spuiten voor een veel egalere verdeling van de verf. Geen rolnerf, geen kwaststrepen \u2013 alleen een strak, gelijkmatig eindresultaat.",
  },
  {
    q: "Is spuiten voordeliger dan schilderen?",
    a: "Bij grotere oppervlaktes vrijwel altijd, ja. Met een airless-spuit werken wij sneller per m\u00B2, waardoor de arbeidskosten lager liggen. De afwerking is bovendien strakker \u2013 mits het door een vakman gebeurt.",
  },
  {
    q: "Hoe lang duurt het voordat de ruimte weer gebruikt kan worden?",
    a: "Latex is meestal binnen 1\u20132 uur stofdroog en na een paar uur over te schilderen. Volledig uitgehard is de verf doorgaans na een dag.",
  },
  {
    q: "In welke regio werken jullie?",
    a: "Wij werken in heel Nederland. Neem gerust contact op, dan kijken we wat we voor u kunnen betekenen.",
  },
];

export const testimonials = [
  {
    name: "Mark de Vries",
    role: "Particulier, Alkmaar",
    text: "Binnen één dag hadden we de hele bovenverdieping strak in een nieuwe laag latex. Echt vakwerk en netjes opgeleverd.",
    rating: 5,
  },
  {
    name: "Linda Bakker",
    role: "Bedrijfspand, Amsterdam",
    text: "DK heeft ons kantoor van 400m² in een weekend gedaan. Op maandagochtend stonden we weer in een fris pand. Top!",
    rating: 5,
  },
  {
    name: "Peter Janssen",
    role: "Particulier, Hoorn",
    text: "Eerlijke prijs, geen verrassingen en het resultaat is super strak. Aanrader voor wie kwaliteit zoekt.",
    rating: 5,
  },
];

export const brands = ["Sikkens", "Wijzonol", "Flexa", "Sigma"];
